import { Column } from "@/components/Datatable/types";
import { TrainingHistoryReportItem } from "../../api/fetchTrainingHistoryReport/types";

export function trainingHistoryReportColumns(): Column<TrainingHistoryReportItem>[] {
  return [
    {
      header: "Company Name",
      accessorKey: "companyName",
      enableSorting: true,
      cell: ({ row }) => row.original.companyName,
    },
    {
      header: "Intacct ID",
      accessorKey: "intacctId",
      cell: ({ row }) => row.original.intacctId ?? "",
    },
    {
      header: "Full Name",
      accessorKey: "fullName",
      enableSorting: true,
      cell: ({ row }) => row.original.fullName,
    },
    {
      header: "Session Dates",
      accessorKey: "sessionStartDate",
      enableSorting: true,
      cell: ({ row }) => row.original.sessionDates,
    },
    {
      header: "Event",
      accessorKey: "eventName",
      enableSorting: true,
      cell: ({ row }) => row.original.eventName,
    },
    {
      header: "Location",
      accessorKey: "locationName",
      enableSorting: true,
      cell: ({ row }) => row.original.location,
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: ({ row }) => row.original.status,
    },
    {
      header: "Certificate",
      // The certificate-generation endpoint is not built yet (future ticket),
      // so present the affordance as disabled rather than linking to a URL
      // that would 404.
      accessorKey: "certificate",
      cell: ({ row }) =>
        row.original.certificate ? (
          <span
            className="cursor-not-allowed text-gray-400 dark:text-slate-500"
            title="Certificate download is not available yet"
          >
            Download (coming soon)
          </span>
        ) : (
          ""
        ),
    },
  ];
}
